<script setup>
import DeviceLoginPage from "@/components/device/login/DeviceLoginPage.vue";
import {useTitle} from "@/utils/metadata";
import {isDeviceLoginAllowed} from "@/views/device/deviceLoginGuard";

const title = useTitle(pgettext('title', 'Device Login'));

const deviceLoginAllowed = isDeviceLoginAllowed();
</script>

<template>
    <div class="flex-fill d-flex justify-center align-start">
        <DeviceLoginPage v-if="deviceLoginAllowed"/>
        <v-card v-else>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text>
                <p>{{ gettext('Use this page to bookmark device login on mobile devices.') }}</p>

                <p class="mt-6">
                    <v-btn :href="reverseUrl('web:account:login')">
                        {{ gettext('Login') }}
                    </v-btn>
                </p>
            </v-card-text>
        </v-card>
    </div>
</template>
